/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

import { Breadcrumb } from "components/atoms/Breadcrumb";
import { SubContentsLayout } from "ui/SubContentsLayout";

interface Props {}
// eslint-disable-next-line unused-imports/no-unused-vars
export const PawTerms: React.FC<Props> = (props) => {
  return (
    <SubContentsLayout>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          ["/", "ホーム"],
          [null, "ポイント約款"],
        ]}
      />

      <div
        css={css`
          padding: 16px 16px 40px;
          margin: 0 auto;
          max-width: 800px;
          iframe {
            width: 100%;
            height: 10100px;
          }
        `}
      >
        <iframe
          title={"ポイント約款"}
          src="https://docs.google.com/document/d/e/2PACX-1vRuwf0td6yuAfUUqmpLKToY_tGsfLCWFRWTkfSKAIywQMwc24qctTYM3RGyPAP1JQ/pub?embedded=true"
        ></iframe>
      </div>
    </SubContentsLayout>
  );
};
